export default {
  unit: {
    input_hint: 'You can express your answer in another unit'
  },
  errors: {
    conversionFailed: 'The conversion failed. Please try with another unit.'
  }
}
